import LoginPage from 'presentation/pages/LoginPage';
import BrokerAccountListPage from 'presentation/pages/brokerAccount/BrokerAccountListPage';
import SelectBrokerAccountPage from 'presentation/pages/brokerAccount/create/SelectBrokerAccountPage';
import ConnectTinkoffBrokerPage from 'presentation/pages/brokerAccount/create/tinkoff/ConnectTinkoffBrokerPage';
import TradernetManualConnectPage from 'presentation/pages/brokerAccount/create/tradernet/ConnectTradernetBrokerPage';
import OrderDetailPage from 'presentation/pages/orders/OrderDetailPage';
import OrderListPage from 'presentation/pages/orders/OrdersPage';
import ProfilePage from 'presentation/pages/profile/ProfilePage';
import CompensationPage from 'presentation/pages/compensation/CompensationPage';
import CreateReportPage from 'presentation/pages/reports/CreateReportPage';
import PeCompanyOrderDetailPage from 'presentation/pages/pe/companyOrders/PeCompanyOrderDetailPage';
import PeDealDetailPage from 'presentation/pages/pe/deals/PeDealDetailPage';
import PeDealsPage from 'presentation/pages/pe/deals/PeDealsPage';
import PeP2POrderDetailPage from 'presentation/pages/pe/p2pOrders/PeP2POrderDetailPage';
import PeOffersPage from 'presentation/pages/pe/PeOffersPage';
import PeSelfOrderDetailPage from 'presentation/pages/pe/selfOrders/PeSelfOrderDetailPage';
import PeSelfOrdersPage from 'presentation/pages/pe/selfOrders/PeSelfOrdersPage';
import NotFound from 'presentation/pages/NotFound';
import { createBrowserRouter } from 'react-router-dom';
import AppRoute from './AppRoute';
import AuthRoute from './AuthRoute';
import ProtectedRoute from './ProtectedRoute';
import HomePage from 'presentation/pages/home/HomePage';
import SelfIpoApplicationsPage from 'presentation/pages/selfIpo/SelfIpoApplicationsPage';
import SelfIpoDetailPage from 'presentation/pages/selfIpo/SelfIpoDetailPage';
import SelfIpoOfferingsPage from 'presentation/pages/selfIpo/SelfIpoOfferingsPage';
import PortfolioPage from 'presentation/pages/portfolio/PortfolioPage';
import OperationsPage from 'presentation/pages/portfolio/OperationsPage';
import PortfolioDealsHistoryPage from 'presentation/pages/portfolio/PortfolioDealsHistoryPage';
import CreatePeOrderPage from 'presentation/pages/pe/CreatePeOrderPage';
import CreatePeCompanyOrderPage from 'presentation/pages/pe/CreatePeCompanyOrderPage';
import PeCompanyDetailPage from 'presentation/pages/pe/company/PeCompanyDetailPage';
import StrategiesPage from 'presentation/pages/strategies/StrategiesPage';
import StrategyDetailPage from 'presentation/pages/strategies/StrategyDetailPage';
import ServiceProductsPage from 'presentation/pages/products/ServiceProductsPage';
import ServiceProductDetailPage from 'presentation/pages/products/ServiceProductDetailPage';
import GeneralSurveyPage from 'presentation/pages/surveys/GeneralSurveyPage';
import EventDetailPage from 'presentation/pages/community/events/EventDetailPage';
import EventListPage from 'presentation/pages/community/events/EventListPage';
import { BrokerType } from 'enums/shared/brokerType';
import ConnectFinamBrokerPage from 'presentation/pages/brokerAccount/create/finam/ConnectFinamBrokerPage';
import PrivateChannelPage from 'presentation/pages/community/PrivateChannel';
import ArticleCommentsPage from 'presentation/pages/community/ArticleComments';
import ConnectBinanceBrokerPage from 'presentation/pages/brokerAccount/create/binance/ConnectBinanceBrokerPage';
import CreateWithdrawalOrderPage from 'presentation/pages/withdrawal/CreateWithdrawalOrderPage';
import WithdrawalOrdersPage from 'presentation/pages/withdrawal/WithdrawalOrdersPage';
import MyDocumentsPage from 'presentation/pages/documents/MyDocumentsPage';
import DocumentDetailPage from 'presentation/pages/documents/DocumentDetailPage';
import TelegramPage from 'presentation/pages/telegram/TelegramPage';
import PerplexityChatView from 'presentation/components/modules/ai/PerplexityChatView';
import NotificationsListPage from 'presentation/pages/notifications/NotificationsListPage';
import NotificationDetailPage from 'presentation/pages/notifications/NotificationDetailPage';
import ScorPage, { ScorSharedEntry } from 'presentation/pages/scor/ScorPage';

const router = createBrowserRouter([
  {
    path: AppRoute.login,
    element: (
      <AuthRoute>
        <LoginPage />
      </AuthRoute>
    ),
  },

  {
    path: AppRoute.home,
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.selfIpo,
    element: (
      <ProtectedRoute>
        <SelfIpoOfferingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.selfIpoApplications,
    element: (
      <ProtectedRoute>
        <SelfIpoApplicationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.selfIpoDetailPath,
    element: (
      <ProtectedRoute>
        <SelfIpoDetailPage />
      </ProtectedRoute>
    ),
  },

  // Portfolio
  {
    path: AppRoute.portfolio,
    element: (
      <ProtectedRoute>
        <PortfolioPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.operationsPath,
    element: (
      <ProtectedRoute>
        <OperationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.dealsHistoryPath,
    element: (
      <ProtectedRoute>
        <PortfolioDealsHistoryPage />
      </ProtectedRoute>
    ),
  },

  // SCOR
  { path: AppRoute.scorSharedViewPath, element: <ScorSharedEntry /> },
  {
    path: `${AppRoute.scor}/*`,
    element: (
      <ProtectedRoute>
        <ScorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.createWithdrawalOrderPath,
    element: (
      <ProtectedRoute>
        <CreateWithdrawalOrderPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.withdrawalOrdersPath,
    element: (
      <ProtectedRoute>
        <WithdrawalOrdersPage />
      </ProtectedRoute>
    ),
  },

  // Strategies
  {
    path: AppRoute.strategies,
    element: (
      <ProtectedRoute>
        <StrategiesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.strategiesDetailPath,
    element: (
      <ProtectedRoute>
        <StrategyDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.serviceProducts,
    element: (
      <ProtectedRoute>
        <ServiceProductsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.serviceProductDetailPath,
    element: (
      <ProtectedRoute>
        <ServiceProductDetailPage />
      </ProtectedRoute>
    ),
  },

  // PE
  {
    path: AppRoute.peOffers,
    element: (
      <ProtectedRoute>
        <PeOffersPage />
      </ProtectedRoute>
    ),
  },

  {
    path: AppRoute.peDeals,
    element: (
      <ProtectedRoute>
        <PeDealsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.peDealDetailPath,
    element: (
      <ProtectedRoute>
        <PeDealDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.peCompanyOrderDetailPath,
    element: (
      <ProtectedRoute>
        <PeCompanyOrderDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.peP2POrderDetailPath,
    element: (
      <ProtectedRoute>
        <PeP2POrderDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.peSelfOrders,
    element: (
      <ProtectedRoute>
        <PeSelfOrdersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.peSelfOrderDetailPath,
    element: (
      <ProtectedRoute>
        <PeSelfOrderDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.createPeOrder,
    element: (
      <ProtectedRoute>
        <CreatePeOrderPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.createPeCompanyOrderPath,
    element: (
      <ProtectedRoute>
        <CreatePeCompanyOrderPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.peCompanyDetailPath,
    element: (
      <ProtectedRoute>
        <PeCompanyDetailPage />
      </ProtectedRoute>
    ),
  },

  // Reports
  {
    path: AppRoute.createReportDetailDetailPath,
    element: (
      <ProtectedRoute>
        <CreateReportPage/>
      </ProtectedRoute>
    ),
  },

  // Orders
  {
    path: AppRoute.recommendations,
    element: (
      <ProtectedRoute>
        <OrderListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.recommendationDetailPath,
    element: (
      <ProtectedRoute>
        <OrderDetailPage />
      </ProtectedRoute>
    ),
  },

  // Profile
  {
    path: AppRoute.profile,
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.notifications,
    element: (
      <ProtectedRoute>
        <NotificationsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.notificationDetailPath,
    element: (
      <ProtectedRoute>
        <NotificationDetailPage />
      </ProtectedRoute>
    ),
  },
  // Online-Documents
  {
    path: AppRoute.myDocumentsPath,
    element: (
      <ProtectedRoute>
        <MyDocumentsPage/>
      </ProtectedRoute>
    ),
  },
  // Documents
  {
    path: AppRoute.documentDetailPath,
    element: (
      <ProtectedRoute>
        <DocumentDetailPage/>
      </ProtectedRoute>
    ),
  },
  // Telegram
  {
    path: AppRoute.telegramPath,
    element: (
      <ProtectedRoute>
        <TelegramPage/>
      </ProtectedRoute>
    ),
  },
  // Compensation
  {
    path: AppRoute.compensationList,
    element: (
        <ProtectedRoute>
          <CompensationPage/>
        </ProtectedRoute>
    ),
  },
  // Broker
  {
    path: AppRoute.brokerList,
    element: (
      <ProtectedRoute>
        <BrokerAccountListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.createBrokerAccount,
    element: (
      <ProtectedRoute>
        <SelectBrokerAccountPage />
      </ProtectedRoute>
    ),
  },

  // Tradernet
  {
    path: AppRoute.connectTradernetBroker,
    element: (
      <ProtectedRoute>
        <TradernetManualConnectPage brokerType={BrokerType.Tradernet} />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.connectFreedomBrokerPath,
    element: (
      <ProtectedRoute>
        <TradernetManualConnectPage brokerType={BrokerType.Freedom} />
      </ProtectedRoute>
    ),
  },

  // Tinkoff
  {
    path: AppRoute.connectTinkoffBroker,
    element: (
      <ProtectedRoute>
        <ConnectTinkoffBrokerPage />
      </ProtectedRoute>
    ),
  },

  // Finam
  {
    path: AppRoute.connectFinamBroker,
    element: (
      <ProtectedRoute>
        <ConnectFinamBrokerPage />
      </ProtectedRoute>
    ),
  },

  // Binance
  {
    path: AppRoute.connectBinanceBroker,
    element: (
      <ProtectedRoute>
        <ConnectBinanceBrokerPage />
      </ProtectedRoute>
    ),
  },

  // Surveys
  {
    path: AppRoute.generalSurvey,
    element: (
      <ProtectedRoute>
        <GeneralSurveyPage />
      </ProtectedRoute>
    ),
  },
  // Ai
  {
    path: AppRoute.aiPath,
    element: (
      <ProtectedRoute>
        <PerplexityChatView/>
      </ProtectedRoute>
    ),
  },
  // Events
  {
    path: AppRoute.privateChannel,
    element: (
      <ProtectedRoute>
        <PrivateChannelPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.privateChannelArticleCommentsPath,
    element: (
      <ProtectedRoute>
        <ArticleCommentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.eventsPath,
    element: (
      <ProtectedRoute>
        <EventListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoute.eventDetailPath,
    element: (
      <ProtectedRoute>
        <EventDetailPage />
      </ProtectedRoute>
    ),
  },

  {
    path: '*',
    element: <NotFound />,
  },
]);

export default router;
